import Icon from 'antd/lib/icon';
import * as React from 'react';

const Container = (props) => (<svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1">
<title>Container</title>
<desc>Created with Sketch.</desc>
<g id="Container" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Group-50-Copy" transform="translate(0.000000, 8.000000)">
        <g id="Group-49">
            <rect id="Rectangle" fill="#333333" x="0" y="0" width="36" height="20.25"></rect>
            <line x1="7.875" y1="5.625" x2="7.875" y2="14.625" id="Line" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="square"></line>
            <line x1="14.625" y1="5.625" x2="14.625" y2="14.625" id="Line-7" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="square"></line>
            <line x1="21.375" y1="5.625" x2="21.375" y2="14.625" id="Line-2" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="square"></line>
            <line x1="28.125" y1="5.625" x2="28.125" y2="14.625" id="Line-3" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="square"></line>
        </g>
    </g>
</g>
</svg>);

const ContainerIcon = props => (
  <Icon component={(innerProps) => {
    return Container(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default ContainerIcon;